import { useEffect, useState } from "react"
import { Spinner } from "asocomponents"
import DocumentoService from "../../../../modules/Documentos/application/DocumentoService.js";
import GrillaAdjuntos from "./GrillaAdjuntos.jsx";
import { useSelector } from "react-redux";
import { setDocumentos } from '../../../redux/observacionSlice.js'
import { useParams } from "react-router-dom";

function GrillaAdjuntoObservacion() {
    const { idObservacion } = useParams()
    const [adjuntos, setAdjuntos] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const documentosCargados = useSelector(state => state.rootReducer.datosObservacion.documentos)

    const obtenerDocumentos = async () => {
        setIsLoading(true)
        const documentosServices = new DocumentoService()
        let documentos = await documentosServices.getDocumentosObservacion(idObservacion)
        setAdjuntos(documentos)
        localStorage.setItem("documentos", JSON.stringify(documentos));
        setIsLoading(false)
    }

    useEffect(() => {
        idObservacion ? obtenerDocumentos() : setAdjuntos(documentosCargados)
    }, [documentosCargados])

    if (isLoading) {
        return <Spinner color="red" size="50" />
    } 

    return (
        <GrillaAdjuntos adjuntos={adjuntos} mostrarBotonAcciones={idObservacion ? true : false} setDocumentos={setDocumentos}/>
    )
}

export default GrillaAdjuntoObservacion